import { z } from 'zod';
import { numericSchema } from './shared/numeric-schema';
import { nullableString } from './shared/nullable-string';
import { isoDateSchema } from './shared/iso-date-schema';

// ─── Entity Schema ────────────────────────────────────────────────────────────

export const userSchema = z.object({
  id: z.string(),
  name: z.string().trim(),
  height: numericSchema,
  mass: numericSchema,
  hair_color: nullableString,
  skin_color: nullableString,
  eye_color: nullableString,
  birth_year: nullableString,
  gender: nullableString,
  homeworld: z.string().trim(),
  films: z.array(z.string()).default([]),
  species: z.array(z.string()).default([]),
  vehicles: z.array(z.string()).default([]),
  starships: z.array(z.string()).default([]),
  created: isoDateSchema,
  edited: isoDateSchema,
});

export type User = z.infer<typeof userSchema>;

// ─── API Response Schemas ─────────────────────────────────────────────────────

export const usersResponseSchema = z.object({
  users: z.array(userSchema),
});

export const userResponseSchema = z.union([z.object({ user: userSchema }), userSchema]);

export type UsersResponse = z.infer<typeof usersResponseSchema>;
export type UserResponse = z.infer<typeof userResponseSchema>;
